import type { MouseEvent, KeyboardEvent } from 'react';

// if the user is holding any key supposed to change the behaviour of the click
// i.e:
//  - holding command (meta) on a mac to open on a new tab or shift for a new window
//  - holding ctrl on windows to open a new tab or alt for a new window
export const isModifiedEvent = (event: MouseEvent | KeyboardEvent): boolean =>
	Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
